import api from './api'

const sasUsersAPI = {
  // Get all SAS users across organizations
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams()
    if (params.search) queryParams.append('search', params.search)
    if (params.status) queryParams.append('status', params.status)
    
    const response = await api.get(`/sas-users?${queryParams.toString()}`)
    return response.data
  },

  // Get SAS users by organization
  getByOrganization: async (organizationId) => {
    const response = await api.get(`/sas-users/organization/${organizationId}`)
    return response.data
  },

  // Get SAS user by ID
  getById: async (userId) => {
    const response = await api.get(`/sas-users/${userId}`)
    return response.data
  },

  // Create SAS user
  create: async (userData) => {
    const response = await api.post('/sas-users', userData)
    return response.data
  },

  // Update SAS user
  update: async (userId, userData) => {
    const response = await api.put(`/sas-users/${userId}`, userData)
    return response.data
  },

  // Delete SAS user
  delete: async (userId) => {
    const response = await api.delete(`/sas-users/${userId}`)
    return response.data
  },

  // Update user status
  updateStatus: async (userId, status) => {
    const response = await api.put(`/sas-users/${userId}`, { status })
    return response.data
  },

  // Update last login
  updateLastLogin: async (userId) => {
    const response = await api.put(`/sas-users/${userId}/last-login`)
    return response.data
  },

  // Get organization stats
  getStats: async (organizationId) => {
    const response = await api.get(`/sas-users/organization/${organizationId}/stats`)
    return response.data
  }
}

export default sasUsersAPI
